import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import ForceGraph2D from "react-force-graph-2d";

const SEV_COLOR = { critical: "#FF2E93", high: "#FF6B00", medium: "#F1D302", low: "#00E5FF", info: "#8B5CF6" };

export default function AttackSurface() {
  const [data, setData] = useState(null);
  const [size, setSize] = useState({ w: 800, h: 600 });
  const wrap = useRef(null);

  useEffect(() => {
    api.get("/assets/graph").then(r => {
      const nodes = r.data.nodes.map(n => ({ ...n }));
      const links = r.data.edges.map(e => ({ source: e.source, target: e.target }));
      setData({ nodes, links });
    });
  }, []);

  useEffect(() => {
    const on = () => {
      if (wrap.current) setSize({ w: wrap.current.clientWidth, h: 620 });
    };
    on();
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);

  return (
    <div className="space-y-6 animate-fade-in" data-testid="attack-surface-page">
      <header>
        <div className="overline mb-2">Topología</div>
        <h1 className="font-display text-4xl font-medium tracking-tight">Grafo de superficie de ataque</h1>
        <p className="text-muted-foreground text-sm mt-1">Dominios → Subdominios → Servicios. Coloreado por severidad de los puertos expuestos.</p>
      </header>

      <div className="flex flex-wrap gap-3 font-mono text-[10px] tracking-widest uppercase text-muted-foreground">
        {Object.entries(SEV_COLOR).map(([k, v]) => (
          <div key={k} className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full" style={{ background: v }} /> {k}
          </div>
        ))}
      </div>

      <div ref={wrap} className="border border-border bg-card/60 relative overflow-hidden" style={{ height: 620 }}>
        {data ? (
          <ForceGraph2D
            graphData={data}
            width={size.w}
            height={size.h}
            backgroundColor="rgba(0,0,0,0)"
            nodeRelSize={4}
            linkColor={() => "rgba(255,255,255,0.12)"}
            linkWidth={0.5}
            nodeCanvasObject={(node, ctx, scale) => {
              const color = SEV_COLOR[node.severity] || "#8B5CF6";
              const r = node.type === "domain" ? 8 : node.type === "subdomain" ? 5 : 3;
              ctx.beginPath();
              ctx.arc(node.x, node.y, r, 0, 2 * Math.PI);
              ctx.fillStyle = color;
              ctx.globalAlpha = 0.9;
              ctx.fill();
              ctx.globalAlpha = 1;
              if (scale > 1.2 || node.type === "domain") {
                ctx.font = `${11 / scale}px 'IBM Plex Mono'`;
                ctx.fillStyle = "rgba(255,255,255,0.85)";
                ctx.textAlign = "center";
                ctx.fillText(node.label, node.x, node.y + r + 10 / scale);
              }
            }}
            cooldownTicks={80}
            d3AlphaDecay={0.03}
            d3VelocityDecay={0.4}
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-muted-foreground font-mono text-sm">Cargando grafo...</div>
        )}
      </div>
    </div>
  );
}
